import { Calendar } from '@powerportalspro/react-calendar';

// Every sample appointment, not only one account's, so a weekday is full.
export function CalendarWorkWeekLayoutSample() {
  return <Calendar defaultLayout="workWeek" defaultTables={['appointment']} height="640px" />;
}
